import React, { Component } from 'react';
import { Row, Navbar, Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Scrollchor from 'react-scrollchor';

//Imagenes
import logo from '../../assets/img/M&F-logo.png';
import logoRed from '../../assets/img/myflogo-red.png';
import logoWhite from '../../assets/img/myflogo-white.png';
import carrito from '../../assets/img/carrito1.png';
import face from '../../assets/img/iconRedes/wireFace.png';

import ig from '../../assets/img/iconRedes/wireIg.png';
//CSS
import './NavBarMenu.css';


class NavBarMenu extends Component {

    constructor(props) {
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
        this.state = { barra: "false", abierto: false };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    handleScroll(event) {
        var target = event.target || event.srcElement;
        if (event.target.scrollingElement.scrollTop > 130) {
            this.setState({ barra: false });
        } else {
            this.setState({ barra: true });
        }
    };

    cerrar() {
        this.setState({ abierto: false });
    }

    onToggle() {
        this.setState({ abierto: !this.state.abierto });
    }


    render() {

        return (
            <Row>
                <Navbar inverse
                    collapseOnSelect
                    fixedTop
                    className={this.state.barra ? "header" : "header-fondo"}
                    expanded={this.state.abierto}
                    onToggle={(e) => this.onToggle()}
                    onBlur={(e) => this.cerrar()}
                >
                    <Navbar.Brand>
                        <Scrollchor to="#inicio">
                            <img className="img-responsive hidden-xs" src={this.state.barra ? logoWhite : logoRed}
                                alt="MyF-Distribuciones" />
                            <img className="img-responsive hidden-sm hidden-lg hidden-md" src={logoRed}
                                alt="MyF-Distribuciones" />
                        </Scrollchor>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse>
                        <Nav pullRight>
                            <li>
                                <Scrollchor to="#inicio" animate={{ offset: -60, duration: 600 }}
                                    onClick={(e) => this.cerrar()}
                                >
                                    Inicio
                                </Scrollchor>
                            </li>
                            <li>
                                <Scrollchor to="#quienessomos" animate={{ offset: -120, duration: 600 }}
                                    onClick={(e) => this.cerrar()}>
                                    Nosotros
                                </Scrollchor>
                            </li>
                            <li>
                                <Scrollchor to="#marcas" animate={{ offset: -60, duration: 600 }}
                                    onClick={(e) => this.cerrar()}
                                >
                                    Marcas
                                </Scrollchor>
                            </li>
                            <li>
                                <Scrollchor to="#servicios" animate={{ offset: -60, duration: 600 }}
                                    onClick={(e) => this.cerrar()}
                                >
                                    Servicio
                                </Scrollchor>
                                {/*<NavLink onClick={(e) => this.cerrar()} to="#servicios">*/}
                                {/*Servicios*/}
                                {/*</NavLink>*/}
                            </li>
                            <li style={{ borderBottom: "none" }}>
                                <NavLink to="/promociones" onClick={(e) => this.cerrar()}>
                                    Promociones
                                </NavLink>
                            </li>

                            <li>
                                <Scrollchor to="#contacto" animate={{ offset: -60, duration: 600 }}
                                    onClick={(e) => this.cerrar()}>
                                    Contacto
                                </Scrollchor>
                            </li>
                            <li className="carrito">
                                <a onClick={(e) => this.cerrar()}
                                    href="https://secure.sig2k.com/webs/myfsrl@sigma.defaultKart/sigkart/3.1/"
                                    target="_blank"
                                >
                                    <img className={this.state.barra ? "invert" : ""} src={carrito}
                                        alt="carrito-compras" />
                                </a>
                            </li>
                            <li className="carrito">
                                <a onClick={(e) => this.cerrar()}
                                    href="https://www.facebook.com/myfdistribucioness/"
                                    target="_blank"
                                >
                                    <img className={this.state.barra ? "invert" : ""} src={face}
                                        alt="facebook" />
                                </a>
                            </li>
                            <li className="carrito">
                                <a onClick={(e) => this.cerrar()}
                                    href="https://www.instagram.com/myfdistribuciones/"
                                    target="_blank"
                                >
                                    <img className={this.state.barra ? "invert" : ""} src={ig}
                                        alt="instagram" />
                                </a>
                            </li>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Row>
        );
    }
}


export default NavBarMenu;



// WEBPACK FOOTER //
// ./src/layout/NavBar/NavBarMenu.js